module.exports = __webpack_public_path__ + "img/animation_wave.ea2545b9.gif";